export default function CTASection() {
  return (
    <section className="relative w-full bg-white border-b border-gray-300 overflow-hidden py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20">
      {/* Background Abstract Images */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/28a7c75437b22657e24a5870bbf5be314ef5950a?width=1450"
          alt=""
          className="absolute right-0 bottom-0 w-1/2 lg:w-auto h-auto opacity-10 lg:opacity-20 translate-x-12 translate-y-12"
          loading="lazy"
        />
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/a0f77260a459cf7e728fd96472f37409a7e58cf1?width=1132"
          alt=""
          className="absolute left-0 bottom-0 w-1/2 lg:w-auto h-auto opacity-10 lg:opacity-20 -translate-x-8"
          loading="lazy"
        />
      </div>

      {/* Content */}
      <div className="relative max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-4 lg:gap-8">
        {/* Text Content */}
        <div className="flex flex-col items-start gap-2 flex-1 z-10">
          <h2 className="text-primary text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%] w-full">
            Start Your Real Estate Journey Today
          </h2>
          <p className="text-black text-sm md:text-base font-normal leading-[150%] w-full">
            Your dream property is just a click away. Whether you're looking for
            a new home, a strategic investment, or expert real estate advice,
            Alkina Realty is here to assist you every step of the way.
          </p>
        </div>

        {/* CTA Button */}
        <button className="flex items-center gap-2 px-4 py-2.5 bg-primary hover:bg-primary/90 transition-all duration-300 z-10 shrink-0 whitespace-nowrap">
          <span className="text-white text-sm font-medium">
            Explore Properties
          </span>
        </button>
      </div>
    </section>
  );
}


